<mat-icon class="mep-dialog-header-icon" svgIcon="mep_bug_icon"></mat-icon>

<div class="popup-content">
	<div class="dialog-container">
		<div class="header-text">
			<span class="mep-dialog-title">{{ "mep.components.bug-report.success" | translate }}</span>
		</div>

		<span class="key-info"
			>{{ "mep.components.bug-report.ticket-name" | translate }}
			<span class="key">
				{{ this.ticket }}
			</span>
		</span>
	</div>
</div>
<div class="mep-dialog-actions">
	<button (click)="dialogRef.close()" class="mep-btn-dialog-secondary" appEscapeHotkey>
		{{ "mep.components.general.close" | translate }}
	</button>
</div>
